<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import { tw } from "@core/utils/svelte/tw.js";
	import { MembershipBenefitCardVariant } from "./MembershipBenefitCardVariant.js";

	const {
		title,
		benefits,
		button,
		subheading,
		variant,
		class: customClass,
	}: {
		title: string;
		benefits: { heading?: string; items: string[] }[];
		button?: Snippet;
		subheading?: string;
		variant: MembershipBenefitCardVariant;
		class?: ClassValue;
	} = $props();

	const variantStyles: Record<MembershipBenefitCardVariant, ClassValue> = {
		[MembershipBenefitCardVariant.White]: tw("bg-fcrbeige text-fcrdarkgray"),
		[MembershipBenefitCardVariant.Brown]: tw("bg-fcrorange text-white"),
		[MembershipBenefitCardVariant.Blue]: tw("bg-fcrblue text-white"),
	};
</script>

<article
	class={[
		"p-10 h-110 rounded-2.5xl flex flex-col max-w-102 w-full md:max-w-86 lg:max-w-94 xl:max-w-102",
		variantStyles[variant],
		customClass,
	]}
>
	<Heading
		level={2}
		class="font-antipol font-bold text-9/tighter min-h-16 my-1 text-center whitespace-break-spaces"
		text={title}
	/>
	<div class="my-auto">
		{#if subheading}
			<Heading level={3} class="font-antipol text-center uppercase mt-5 max-w-[22ch] mx-auto mb-6" text={subheading} />
		{/if}
		{#each benefits as section, sectionIndex (sectionIndex)}
			{#if section.heading}
				<p class="font-antipol mt-5 mb-1.5 uppercase [h3+&]:mt-0">{section.heading}</p>
			{/if}
			<ul class="list-disc pl-8 text-sm/normal">
				{#each section.items as benefit, itemIndex (itemIndex)}
					<li><Formatted text={benefit} /></li>
				{/each}
			</ul>
		{/each}
	</div>

	{@render button?.()}
</article>
